import { DomainRedirectURL, HubLoginURL } from "../../utils/constants";

const Login = () => {
  window.location.replace(HubLoginURL + DomainRedirectURL);
  return null;
}

export default Login;
